// extracted by css-extract-rspack-plugin
export default {"labelDescriptionTooltip":"Label-module__labelDescriptionTooltip__kWymG","hiddenTooltip":"Label-module__hiddenTooltip__ttp9Y"};